/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsGooglePublicAuthOptions, FxIdDomainSettingsGooglePublicAuthOptionsFromJSONTyped, FxIdDomainSettingsGooglePublicAuthOptionsToJSON, } from './FxIdDomainSettingsGooglePublicAuthOptions';
export function FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigGoogleFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigGoogleFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigGoogleFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsGooglePublicAuthOptions(json)) {
        return FxIdDomainSettingsGooglePublicAuthOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigGoogleToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigGoogleToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigGoogleToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsGooglePublicAuthOptions(value)) {
        return FxIdDomainSettingsGooglePublicAuthOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigGoogle.js.map